import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { GenericDialogContainer } from '@moderepo/mode-app-components';
import { useRitzTranslation } from '../../utils/customHooks';
import { LanguageSelectorContainer } from '../language-selector/LanguageSelectorContainer';


/**
 * This is the wrapper for the GenericDialog.
 */
export const GenericDialogProvider: React.FC = () => {
    const params = useParams();
    const projectId = params.projectUd ? Number(params.projectId) : undefined;
    const { state:dataState } = useContext(ritzDataContext);
    const project = projectId ? selectProjectById(dataState, projectId) : undefined;
    const { trans } = useRitzTranslation(project);

    return (
        <GenericDialogContainer
            translator={trans}
            languageSelectorComponent={<LanguageSelectorContainer projectId={projectId} minimal />}
        />
    );
};
